export default __webpack_public_path__ + "static/media/5.bb0c1561.jpg";